import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import SimpleButtonModel, { NULL as SimpleButtonModelNULL } from './model'
import findAncestor from '@client/utils/findAncestor'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import { defaultSettings, DEFAULT_PADDING } from './constants'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { FORM_BUTTON_ALIGN_OPTIONS } from '@client/components/blocks/Form/constants'

import inlineStyles from './inlineStyles'

const PADDING = 2 * DEFAULT_PADDING

export class SimpleButton extends Component {
  static propTypes = {
    model: PropTypes.instanceOf(SimpleButtonModel),
    editor: PropTypes.instanceOf(EditorModel),
    app: PropTypes.instanceOf(AppModel),
    serverRender: PropTypes.bool,
  }

  static defaultProps = {
    model: SimpleButtonModelNULL,
    editor: EditorModelNULL,
    app: AppModelNULL,
    serverRender: false,
  }

  componentDidMount() {
    this.column = findAncestor(this.dom, 'column')
    this.setContainerDimentions()
    if (this.column) {
      this.resizeObserver = new ResizeObserver(() => this.setContainerDimentions())
      this.resizeObserver.observe(this.column)
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  calculateStyles = (settings, globalSettings) => {
    const align = settings.align || globalSettings.button_simple_align
    const height = settings.height || globalSettings.button_height
    const borderStyle =
      settings.borderStyle || globalSettings.button_borderStyle
    const borderColor =
      settings.borderColor || globalSettings.button_borderColor
    const borderWidth =
      settings.borderWidth || globalSettings.button_borderWidth
    return {
      width: align === FORM_BUTTON_ALIGN_OPTIONS[3].value ? '100%' : 'auto',
      minWidth:
        align === FORM_BUTTON_ALIGN_OPTIONS[3].value ? '100%' : undefined,
      lineHeight: typeof height === 'undefined' ? undefined : height + 'px',
      maxHeight: typeof height === 'undefined' ? undefined : 2 * +height + 'px',
      fontSize: (settings.fontSize || globalSettings.button_fontSize) + 'px',
      border: borderWidth
        ? `${borderWidth}px ${borderStyle} ${borderColor}`
        : 'none',
      borderRadius:
        (settings.borderRadius || globalSettings.button_borderRadius) + 'px',
      background:
        settings.backgroundColor || globalSettings.button_backgroundColor,
      color: settings.textColor || globalSettings.button_textColor,
      paddingLeft:
        align === FORM_BUTTON_ALIGN_OPTIONS[3].value
          ? 0
          : inlineStyles.a.paddingLeft,
      paddingRight:
        align === FORM_BUTTON_ALIGN_OPTIONS[3].value
          ? 0
          : inlineStyles.a.paddingRight,
    }
  }

  setContainerDimentions() {
    if (!this.column) {
      return
    }
    this.props.model.setContainerDimensions({
      width: this.column.clientWidth - PADDING,
    })
  }

  render() {
    const globalSettings = this.props.editor.settings.values
    const settings = this.props.model.settings.values
    const styles = {
      ...inlineStyles.a,
      ...this.calculateStyles(settings, globalSettings),
      fontFamily: globalSettings.normalText_fontFamily,
    }
    const formatMessage = this.props.app.formatMessage

    const text = settings.text || ''

    return (
      <div
        style={{ padding: '5px 0' }}
        className={this.props.serverRender ? '' : 'button'}
        align={(settings.align || globalSettings.button_simple_align)
          .replace('text-', '')
          .replace('full-width', '')}
        ref={(el) => (this.dom = el)}
      >
        <a
          className="btn"
          href={settings.url || defaultSettings.url}
          target="_blank"
          rel="noopener noreferrer"
          role="link"
          style={styles}
          onClick={(ev) => {
            if (!settings.url) {
              ev.preventDefault()
            }
          }}
        >
          {text ? (
            <span
              style={{
                color: settings.textColor || globalSettings.button_textColor,
                fontWeight:
                  settings.fontWeight || globalSettings.button_fontWeight,
              }}
            >
              {defaultSettings.text === text
                ? formatMessage(defaultSettings.text)
                : text}
            </span>
          ) : (
            <span
              style={{
                color: settings.textColor || globalSettings.button_textColor,
                fontWeight:
                  settings.fontWeight || globalSettings.button_fontWeight,
              }}
              dangerouslySetInnerHTML={{
                __html: '&nbsp;',
              }}
            />
          )}
        </a>
      </div>
    )
  }
}

export default inject('editor', 'app', 'serverRender')(observer(SimpleButton))
